import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../../../public/splashPage/avatars/luke.webp'

export const LukeImage: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'Luke'} />
)
